<template>
  <div class="md:py-12 lg:py-12 py-6 lg:mt-12 md:mt-10 mt-0 relative">
    <modal :show.sync="editModal" header-classes="bg-primary p-7" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold"
      >
        Caregiver Saathi
      </h6>
      <div class="mt-5">
        <p class="mt-2 input-title-black">By submitting this form:</p>
        <p class="mt-2 input-title-black">
          1) You let Caregiver Saathi and its partners use this data for
          insights and analytics. You are not flooded with unnecessary
          information, and it enables us to send you more relevant information
          and resources to support you.
        </p>
        <p class="mt-2 input-title-black">
          2) You agree to be contacted with information and future programs,
          events,promotions, pertaining to the areas of interest you have
          specified in this form.
        </p>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly-hcp mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="relative">
      <div class="">
        <div class="md:w-3/5 lg:w-2/5 w-3/5 bg-b5e7f7">
          <img
            src="../../../assets/images/caregiver/mbr-bg.svg"
            alt="bg polygon"
          />
        </div>
      </div>
      <div class="lg:flex md:flex gap-2 absolute top-4 lg:px-10 md:px-10 px-5">
        <div class="lg:w-1/2 md:w-1/2">
          <p
            class="title w-full sm-fsize16 lg:font-medium md:font-medium font-bold"
          >
            Customized Services
          </p>
          <div class="lg:w-1/2 md:w-4/5">
            <p class="subtitle md:pt-6 lg:pt-6 pt-2 w-full fsize20 sm-fsize14">
              We understand that the needs of organisations differ depending on
              your company size, maturity, values and goals. We offer customised
              curriculums that suits your specific requirements, making them
              relevant, impactful, and objective driven.
            </p>
            <p
              class="subtitle fsize20 sm-fsize14 pt-2 w-full fsize18-14-32px lg:mb-0 md:mb-0 mb-8"
            >
              Share with us details about your organisation and what you are
              aiming for. Fill in the inquiry form below and we will get in
              touch!
            </p>
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 formposition md-rightcoporate">
          <div
            class="col-span-2 bg-primary md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative trans-zoom-half"
            id="Contact-Us"
          >
            <div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
                  <div class="flex justify-between">
                    <p
                      class="font-bold text-white fsize35 sm-fsize20 md-fsize25 mb-2"
                    >
                      For Customised Corporate Programmes - Contact Us
                    </p>
                    <!-- <div class="md:hidden lg:hidden block clr858585">
                        <p class="mbr-title mb-2 text-2xl-imp clr858585">
                          Price - ₹0.00
                        </p>
                      </div> -->
                  </div>
                  <div
                    class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-3 gap-x-5 gap-y-6"
                  >
                    <div class="">
                      <p class="input-title">Name</p>
                      <base-input
                        v-model="name"
                        placeholder="Enter your name"
                        class="md:border-0 lg:border-0"
                        name="Name"
                        :rules="{ required: true, alpha_spaces: true }"
                      ></base-input>
                    </div>
                    <div class="mob-hidden">
                      <p class="input-title">Email Address</p>
                      <base-input
                        v-model="email"
                        placeholder="Enter your EmailID"
                        class="md:border-0 lg:border-0"
                        name="Email"
                        :rules="{ required: true, email: true }"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title">Designation</p>
                      <base-input
                        v-model="designation"
                        placeholder="Enter your Designation"
                        class="md:border-0 lg:border-0"
                        name="Designation"
                        :rules="{ required: true }"
                      ></base-input>
                    </div>
                    <div class="mob-hidden">
                      <p class="input-title">Company Name</p>
                      <base-input
                        v-model="company"
                        placeholder="Enter your Company Name"
                        class="md:border-0 lg:border-0"
                        name="Company Name"
                        :rules="{ required: true }"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title">Mobile No.</p>
                      <base-input
                        v-model="mobile"
                        placeholder="Enter your Mobile No."
                        class="md:border-0 lg:border-0"
                        name="Mobile No."
                        :rules="{
                          required: true,
                          numeric: true,
                          min: 10,
                          max: 10,
                        }"
                      ></base-input>
                    </div>
                  </div>
                  <div class="pt-6">
                    <p class="input-title">
                      Please give us an impression of your workplace needs
                    </p>
                    <b-form-textarea
                      v-model="message"
                      placeholder="Enter your Message"
                      rows="2"
                      class="md:border-0 lg:border-0"
                    ></b-form-textarea>
                  </div>
                  <div class="md:mt-6 mt-6 lg:mt-8 bottom6-4 w-full">
                    <b-form-checkbox
                      :disabled="isValidForm"
                      id="checkbox-1"
                      value=" I have read and agreed to these"
                      unchecked-value="I have read and agreed to these"
                      v-model="status"
                    >
                      <p>
                        <strong
                          >{{ status }}
                          <u class="ublue" @click="editModal = true"
                            >terms and conditions</u
                          ></strong
                        >
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="md:mt-6 mt-6 lg:mt-8 bottom6-4 w-full">
                    <b-button
                      type="submit"
                      :disabled="isdisabled"
                      variant="secondary"
                      class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
                      >Submit</b-button
                    >
                  </div>
                </b-form>
              </validation-observer>

              <div class="absolute bottom-0 right--6rem mob-hidden md-right--1">
                <img
                  src="../../../assets/images/2plants.svg"
                  alt="plant"
                  class="md-w-130px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";

export default {
  mixins: [emailMixin],
  data() {
    return {
      name: "",
      email: "",
      designation: "",
      company: "",
      mobile: "",
      message: "",
      status: "I have read and agreed to these",
      editModal: false,
    };
  },
  methods: {
    async reset() {
      this.name = "";
      this.email = "";
      this.designation = "";
      this.company = "";
      this.mobile = "";
      this.message = "";
    },
    async handleSend() {
      const to = ["Bhavana.issar@caregiversaathi.co.in"];
      const bcc = [
        "vimala.mv@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];
      // const to = [
      //   "Bhavana.issar@caregiversaathi.co.in",
      //   "vimala.mv@caregiversaathi.co.in",
      // ];
      const subject = "Customized Corporate Programmes";
      const body = `
      Name: ${this.name}<br />
      Email Address: ${this.email}<br />
      Designation: ${this.designation}<br />
      Company Name: ${this.company}<br />
      Mobile No.: ${this.mobile}<br />
      Message: ${this.message}<br />
      `;
      await this.sendEmail(to, subject, body, [], bcc);
      this.$refs.formValidator.reset();
      this.reset();
      this.successAlert();
    },
  },
  computed: {
    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (
        this.name != "" &&
        this.email != "" &&
        this.designation != "" &&
        this.company != "" &&
        this.mobile != "" &&
        this.message != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    isdisabled() {
      if (this.status == "I have read and agreed to these") {
        return true;
      } else {
        return false;
      }
    },
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.name = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
      this.designation = this.user["designation"]
        ? this.user["designation"]
        : "";
      this.company = this.user["companyName"] ? this.user["companyName"] : "";
    }
  },
};
</script>
<style>
.ublue {
  color: rgb(86, 86, 248);
}
</style>
